module.exports = __webpack_public_path__ + "img/css3.8436e4bb.svg";